import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { trackEvent } from "@/lib/analytics";

const StudentStudyLogitech = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Helmet>
        <title>Studentstudie – Logitech & AI-labbet</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="Utbildning för deltagare i studentstudien med Logitech och AI-labbet."
        />
      </Helmet>

      <Header />

      <main className="flex-1 pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-8">
            Studentstudie – AI-labbet & Logitech
          </h1>

          <p className="text-lg text-foreground/80 leading-relaxed mb-10">
            Tack för att du deltar i vår studentstudie tillsammans med Logitech.
            Syftet med studien är att undersöka hur rätt teknik kan bidra till
            bättre studieresultat. Nedan kan du ta del av en kort utbildning om
            den utrustning du som student får tillgång till. Genom att gå
            utbildningen får du en bättre förståelse för hur utrustningen
            fungerar och hur du använder den på bästa sätt för att maximera
            både möjligheterna och värdet i dina studier.
          </p>

          <div className="rounded-lg overflow-hidden shadow-lg bg-black">
            <video
              controls
              preload="metadata"
              playsInline
              className="w-full aspect-video"
              onPlay={() => trackEvent("video_start", { video_title: "student_study_logitech" })}
              onEnded={() => trackEvent("video_complete", { video_title: "student_study_logitech" })}
            >
              <source
                src="https://egcaicjdxjtvjzljbvyq.supabase.co/storage/v1/object/public/student-videos/student-study-logitech.mp4"
                type="video/mp4"
              />
              Din webbläsare stödjer tyvärr inte uppspelning av videon.
            </video>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default StudentStudyLogitech;
